var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-header-actions"},[_c('notification-drop-down',{attrs:{"variant":"cta"}}),_c('vs-button',{staticClass:"admin-header-refresh",attrs:{"icon-pack":"feather","icon":"icon-refresh-ccw","disabled":_vm.refreshing},on:{"click":_vm.refreshAll}},[_vm._v("\n    Refresh\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }